<template>
  <div class="track-slider" :class="theme">

    <kl-icon v-if="theme != 'dark'" @click="prevClick" icon="icon-icon_paly_rewind" border style="cursor: pointer" />
    <kl-icon v-if="theme != 'dark'" :icon="current_play_state ? 'icon-icon_paly' : 'icon-icon_operat_after1'" border
      style="margin-left: 8px; cursor: pointer" @click="togglePlay" />
    <kl-icon v-if="theme != 'dark'" @click="nextClick" icon="icon-icon_paly_forward" border
      style="margin-left: 8px; cursor: pointer" />
    <img v-if="theme == 'dark' && current_play_state" @click="togglePlay"
      :src="require('@/assets/images/ic_guiji_zanting@2x.png')" alt=""
      style="width: 24px; height: 24px; margin-left: 8px; cursor: pointer" />
    <img v-if="theme == 'dark' && !current_play_state" @click="togglePlay"
      :src="require('@/assets/images/ic_guiji_bofang@2x.png')" alt=""
      style="width: 24px; height: 24px; margin-left: 8px; cursor: pointer" />

    <div style="flex: 1; display: inline-block; margin-left: 8px">
      <el-slider v-model="myValue" :max="max" :show-tooltip="false" size="mini"></el-slider>
    </div>
    <div style="
        display: inline-block;
        font-size: 12px;
        color: #000000;
        margin: 0 8px;
      ">
      <span class="number"> <span>{{ myValue + 1 }}</span>/<span>{{ myMax }}</span></span>
    </div>

    <el-select placeholder="" v-model="playSpeed" size="mini" style="width: 70px">
      <el-option :label="$t('vehicletrack.normal')" :value="1000"> </el-option>
      <el-option label="X0.5" :value="2000"> </el-option>
      <el-option label="X2" :value="500"> </el-option>
      <el-option label="X4" :value="250"> </el-option>
      <el-option label="X8" :value="120"> </el-option>
      <el-option label="X16" :value="60"> </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'normal',
    },
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      myValue: this.value,
      myMax: this.max,
      timer: undefined, //定时器
      playSpeed: 1000, //播放速度，定时器速度
      current_play_state: false, // 播放状态
    };
  },
  
  beforeDestroy() {
    console.log("track-destroy");
    if (this.timer) clearInterval(this.timer);
  },
  watch: {
    myValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.myValue = val;
    },
    myMax() {
      // console.log(this.myMax);
      // console.log("sdfds");
      // //启动定时器，定时显示轨迹点
      // this.current_play_state = true;
      // console.log(this.current_play_state);
      // this.resetTimer();
    },
    max(val) {
      this.myMax = val;
    },
    playSpeed() {
      this.resetTimer();
    },
  },
  methods: {
    prevClick() {
      if (this.myValue > 0) {
        this.myValue--;
      }
    },
    nextClick() {
      if (this.myValue < this.myMax-1) {
        this.myValue++;
      }
    },
    play() {
      this.current_play_state = true;
      if (this.current_play_state) {
        this.resetTimer();
      } else {
        clearInterval(this.timer);
      }
    },
    // 新增播放控制方法
    togglePlay() {
      this.current_play_state = !this.current_play_state;
      if (this.current_play_state) {
        this.resetTimer();
      } else {
        clearInterval(this.timer);
      }
    },
    resetTimer() {
      if (this.timer) clearInterval(this.timer);
      this.current_play_state = true;
      this.timer = setInterval(() => {
        this.myValue++;
        if (this.myValue >= this.myMax-1) {
          // this.current_play_state = false;
          console.log(this.current_play_state);
          if (this.timer) clearInterval(this.timer);
          return;
        }
        
      }, this.playSpeed);
    },
  },
};
</script>
<style scoped>
.track-slider {
  display: flex;
  align-items: center;
  width: 100%;
}

.number {

  color: #2a7aff
}

.dark {
  .el-select>.el-input>.el-input__inner {
    background-color: transparent !important;
    color: #fff !important;
    border: 0 !important;
  }

  .number {
    color: #fff;
  }
}
</style>
